module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-next-button"
  }, [_c('div', {
    staticClass: "page-next-button__btn",
    on: {
      "touchstart": _vm.clickHandler,
      "click": _vm.clickHandler
    }
  }, [_c('div', {
    staticClass: "page-next-button__label"
  }, [_vm._v("Verder")]), _vm._v(" "), _c('i', {
    staticClass: "page-next-button__image fa fa-arrow-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146e433c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-next-button/page-next-button.vue
// module id = 134
// module chunks = 0